
import {SEARCH_ITEMS_ADD, SEARCH_ITEMS_RESET} from './searchActionTypes'

export function searchAddItem(data){
    return (dispatch) => dispatch({type:SEARCH_ITEMS_ADD, payload:data})
}

export function searchItemReset(){
    return (dispatch)=> dispatch({type:SEARCH_ITEMS_RESET})
}